// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"Avatar_avatarWrapper__rRDI3","editBtn":"Avatar_editBtn__5b49A"};